import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-online-exam',
  templateUrl: './online-exam.component.html',
  styleUrls: ['./online-exam.component.scss']
})
export class OnlineExamComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
